// Ebene für schwebende Listen in Sheets und Dialogen (DESIGN §2.9): Radix-Portale hängen am Ende
// von `body`, deshalb läge ein Popover (z 40) unter dem Dialog (z 60). Sheet und Dialog geben ihre
// Ebene über Kontext weiter; Popover, Select, Combobox, Menü und Kalender übernehmen sie und liegen
// dank der späteren Portal-Reihenfolge darüber („Ebene + 1“).
import { createContext, useContext, type CSSProperties, type ReactNode } from 'react';

const LayerContext = createContext<string | undefined>(undefined);

/** `z` als CSS-Wert, z. B. `var(--bar-z-dialog)`. */
export function LayerProvider({ z, children }: { z: string; children: ReactNode }) {
  return <LayerContext.Provider value={z}>{children}</LayerContext.Provider>;
}

/** Inline-Stil für Portal-Inhalte: z-index der umgebenden Ebene, sonst nichts (Klasse gilt). */
export function useLayerStyle(style?: CSSProperties): CSSProperties | undefined {
  const z = useContext(LayerContext);
  if (!z) return style;
  return { ...style, zIndex: z };
}
